import { create } from 'zustand'
import type { StoreApi, UseBoundStore } from 'zustand'

interface TrialActivationConfirmDialogStore {
  isOpen: boolean
}

interface Slot {
  store: UseBoundStore<StoreApi<TrialActivationConfirmDialogStore>>
  pendingResolve: ((confirmed: boolean) => void) | null
}

const GLOBAL_KEY = '__cfTrialActivationConfirmDialog__' as const

function getSlot(): Slot {
  const globalWithSlot = globalThis as typeof globalThis & { [GLOBAL_KEY]?: Slot }
  const existing = globalWithSlot[GLOBAL_KEY]
  if (existing) {
    return existing
  }
  const created: Slot = {
    store: create<TrialActivationConfirmDialogStore>(() => ({ isOpen: false })),
    pendingResolve: null,
  }
  globalWithSlot[GLOBAL_KEY] = created
  return created
}

export const useTrialActivationConfirmDialogStore = getSlot().store

export function requestTrialActivationConfirm(): Promise<boolean> {
  const slot = getSlot()
  slot.pendingResolve?.(false)
  const { promise, resolve } = Promise.withResolvers<boolean>()
  slot.pendingResolve = resolve
  slot.store.setState({ isOpen: true })
  return promise
}

export function resolveTrialActivationConfirm(confirmed: boolean) {
  const slot = getSlot()
  const resolve = slot.pendingResolve
  slot.pendingResolve = null
  slot.store.setState({ isOpen: false })
  resolve?.(confirmed)
}
